angular.module('wbControllers').controller 'LoginController',
['$scope', '$location', '$route', 'users', 'storage', 'analytics', ($scope, $location, $route, users, storage, analytics) ->
    @user = users.getCurrentUser() || {}
    @message = null
    @forgotPassword = false
    @shouldUseSSO = false
    @state = undefined
    @rememberMe = storage.getItem('rememberMe') == 'true' ? true : false

    $scope.$watch 'ctrl.user.email', (value) =>
      if !value || !value.match(/@wealthbar\.com$/)
        @shouldUseSSO= false
      else
        @shouldUseSSO= true

    $scope.$watch 'ctrl.rememberMe', (value) =>
      storage.setItem('rememberMe', value)

    $scope.$watch 'loginDialog.visible', (value) =>
      if value is false
        @user.email = null unless @rememberMe
        @user.password = null
        @message = null
        @forgotPassword = false
        @newPasswordSent = false

    @showForgotPassword = =>
      if @shouldUseSSO
        return
      @forgotPassword = true
      @newPasswordSent = false
      reset()

    @showLogin = =>
      @forgotPassword = false
      reset()

    reset = => @message = null

    @showLoginViaSSO = =>
      @forgotPassword = false

    @login = =>
      if @shouldUseSSO is false
        @loginWithPassword()
      else
        @loginViaSSO()

    @loginWithPassword = =>
      @state = 'logging-in'
      users.signin(@user)
        .then (r) =>
          # Track signins for analytics
          if analytics && analytics.alias && analytics.track
            analytics.alias(users.getCurrentUser().id)
            analytics.track 'Signin', {
              category: 'User', label: 'Success'
            }
          if $scope.loginDialog
            $scope.loginDialog.hide()
            @state = undefined
          if r.promptTwoFactorSignup
            window.location = '/app/two-factor-signup'
          else if $route.current
            $route.reload()
          else
            window.location = '/signin/continue'
        .catch (e) =>
          if e.status is 499
            $scope.loginDialog.hide() if $scope.loginDialog
            $scope.twoFactorDialog.show(e.data.tfaMethod)
            @user.id = e.data.userId
            @state = undefined
          else
            @state = 'error'
            @message = e.data?.message
            # Clear password on failed login
            @user.password = ''

    @loginViaSSO = =>
      @state = 'redirecting'
      destination= $location.search().return_to
      if (destination && !destination.match(/(:|%3a|\/\/|%2F%2F)/i))
        window.location = '/sso/initiate?return_to=' + destination
      else
        window.location = 'sso/initiate'

    @submitToken = (token, rememberDevice) =>
      @state = 'submitting'
      users.confirmTwoFactorAuth(token, rememberDevice)
        .then (r) =>
          if $scope.twoFactorDialog
            $scope.twoFactorDialog.hide()
          if $location.search().return_to?
            window.location = $location.search().return_to
          else if $route.current
            $route.reload()
          else
            window.location = '/app/dashboard'
        .catch (e) =>
          @state = 'error'
          @message = e.data.message

    @resetPassword = ->
      return if sendingPasswordReset
      sendingPasswordReset = true
      users.resetPassword @user,
        success: =>
          @forgotPassword = false
          @newPasswordSent = true
          sendingPasswordReset = false
        error: (e) =>
          @message = e.data.message
          sendingPasswordReset = false

    @requestNewToken = ->
      users.requestTwoFactorAuth()
      $scope.token = null
      @error = null
      @state = 'submit'

    @
]
